import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  signal,
} from '@angular/core';
import { ModalService } from '@features/modals/services/modal.service';
import { InventoryTemplateComponent } from '@core/components/inventory-template/inventory-template.component';
import { SocketService } from '@core/services/socket.service';
import { Skin } from '@core/interfaces/skin.interface';
import { BalanceEnum } from '@core/enums/balance.enum';
import { sleep } from '@core/utils/sleep.util';

@Component({
  selector: 'app-deposit-modal',
  imports: [InventoryTemplateComponent],
  templateUrl: './deposit-modal.component.html',
  styleUrl: './deposit-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DepositModalComponent {
  readonly type = input<keyof typeof BalanceEnum>(BalanceEnum.skins);
  readonly selectedSkins = model<Skin[]>([]);
  readonly isProcessing = signal(false);

  constructor(
    private socketService: SocketService,
    private modalService: ModalService
  ) {}

  public async depositItems() {
    this.isProcessing.set(true);
    try {
      const trade: { offerid: number; hash: string } =
        await this.socketService.emit('market_deposit', {
          skins: this.selectedSkins(),
          balance: this.type(),
        });

      this.modalService.openModal('TradeModal', {
        tradeModalOptions: {
          trade_offer_id: trade.offerid,
          trade_hash: trade.hash,
          trade_skins: this.selectedSkins(),
          typography_trade_for:
            this.type() === BalanceEnum.pure
              ? 'deposit the pure items'
              : 'deposit the skins items',
        },
        balance: this.type(),
      });
      this.modalService.closeModals(['DepositModal']);
    } catch {
    } finally {
      this.isProcessing.set(false);
    }
  }
}
